// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"532":"styles","678":"component---src-pages-index-js","774":"framework","802":"94726e6d"}[chunkId] || chunkId) + "-" + {"223":"f31a38951d75a3853625","532":"9358739d364dae5d8443","622":"7fff2551e30f5f5118b8","678":"0ea4cdb38f190d5e712a","774":"d7af66f706e1048c7da4","802":"03ae9b0f97c89a73fb17"}[chunkId] + ".js";
};